import { FC } from 'react';

// Third-party
import { styled } from '@mui/material/styles';

// Types
import { TToolbarWrapper } from './type';

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  padding: theme.spacing(3, 0),
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    padding: theme.spacing(1.75, 3),
    justifyContent: 'space-between',
  },
  [theme.breakpoints.only('xs')]: {
    alignItems: 'unset',
    padding: theme.spacing(0, 0),
  },
}));
const ToolbarWrapper: FC<TToolbarWrapper> = ({ children }) => (
  <RootStyle>
    {children}
  </RootStyle>
);

export {
  ToolbarWrapper,
};
